module.exports = __webpack_public_path__ + "img/11_57.9a565a7c.png";